import React from "react";
import { Alert, Button, Select, Space, Typography } from "antd";
import { ArrowDownOutlined, ArrowUpOutlined } from "@ant-design/icons";
import { useStoreWarehouseChoices } from "../useStoreConfigurationResources";

export default function StoreWarehouseSelector({ primaryWarehouseId, value = [], onChange, disabled = false }: {
  primaryWarehouseId: number; value?: number[]; onChange?: (ids: number[]) => void; disabled?: boolean;
}) {
  const resource = useStoreWarehouseChoices();
  const warehouses = resource.data || [];
  const ownerAvailable = warehouses.some((warehouse) => warehouse.id === Number(primaryWarehouseId));
  const unavailable = value.some((id) => !warehouses.some((warehouse) => warehouse.id === Number(id)));
  const reorder = (index: number, delta: number) => {
    const next = [...value];
    [next[index], next[index + delta]] = [next[index + delta], next[index]];
    onChange?.(next);
  };
  const blocked = disabled || !resource.data || Boolean(resource.error) || !ownerAvailable;
  return <Space direction="vertical" style={{ width: "100%" }}>
    {resource.error && <Alert type="error" showIcon message="Les établissements n'ont pas pu être actualisés. Votre sélection est conservée."
      action={<Button onClick={() => void resource.refresh().catch(() => {})}>Réessayer</Button>} />}
    {resource.data && (unavailable || !ownerAvailable) && <Alert type="warning" showIcon
      message="Un établissement sélectionné est indisponible. Vérifiez les participants avant d'enregistrer." />}
    <Select mode="multiple" aria-label="Établissements participants" value={value.map(Number)} loading={resource.loading}
      style={{ width: "100%" }} optionFilterProp="label" placeholder="Sélectionner les établissements" disabled={blocked}
      onChange={onChange} options={[...warehouses.map((warehouse) => ({ value: warehouse.id, label: warehouse.name })),
        ...value.filter((id) => !warehouses.some((warehouse) => warehouse.id === Number(id)))
          .map((id) => ({ value: Number(id), label: "Établissement indisponible", disabled: true }))]} />
    <Button size="small" disabled={blocked || resource.loading} onClick={() => onChange?.(warehouses.map((warehouse) => warehouse.id))}>
      Tous les établissements accessibles de l'entreprise
    </Button>
    {value.length > 1 && <ol className="store-config-source-order">{value.map((id, index) => {
      const name = warehouses.find((warehouse) => warehouse.id === Number(id))?.name || "Établissement indisponible";
      return <li key={id}><span>{String(index + 1).padStart(2, "0")}. {name}</span><Space size={4}>
        <Button size="small" icon={<ArrowUpOutlined />} aria-label={`Augmenter la priorité de ${name}`}
          disabled={blocked || index === 0} onClick={() => reorder(index, -1)} />
        <Button size="small" icon={<ArrowDownOutlined />} aria-label={`Diminuer la priorité de ${name}`}
          disabled={blocked || index === value.length - 1} onClick={() => reorder(index, 1)} />
      </Space></li>;
    })}</ol>}
    <Typography.Text type="secondary">L'ordre définit la priorité des sources et du prix hérité. Un établissement peut alimenter plusieurs boutiques. Les futurs établissements devront être sélectionnés ici.</Typography.Text>
  </Space>;
}
